import { Layout } from "../../../components/Layout";
import { Column, Grid, Row } from "carbon-components-react";
import { useLocation } from "react-router-dom";

export default function CertificateCreation() {
  const { pathname } = useLocation();
  return (
    <>
      <div className="doc-content">
        <h3 className="doc-title">Certificate Creation</h3>

        <p className="text-in pb-8 black">
          For security reasons, merchants communicate with TWEC PG using
          certificates. Each merchant receives an archive file. After extracting
          the file, follow these steps to generate a certificate request:
        </p>
        <div className="file-content">
          <div className="text-line pb-24">
            <span>
              1. Run the<span className="tag">request.bat</span>file.
            </span>
            <ul className="pt-12">
              <li>This will generate a certificate request.</li>
            </ul>
          </div>
          <div className="text-line">
            <span>2. Fill in the required fields.</span>
            <ul className="pt-12">
              <li>
                <strong>Country Name (2-letter code) [GE]:</strong> By default,
                the Georgian country code is set. Press Enter to confirm.
              </li>
              <li>
                <strong>State or Province Name (full name) [Georgia]: </strong>{" "}
                By default, set to Georgia.
              </li>
              <li>
                <strong>Locality Name (e.g., city) [Tbilisi]: </strong> By
                default, set to Tbilisi. If your organization is registered in a
                different city, enter its name.
              </li>
              <li>
                <strong> Organization Name (e.g., company) []: </strong> Enter
                the name of your organization.
              </li>
              <li>
                <strong> Organizational Unit Name (e.g., section) []: </strong>{" "}
                Specify the department name (e.g., IT Department).
              </li>

              <li>
                <strong>Common Name (e.g., YOUR name) []:</strong>Enter your
                company’s web address without “www” (e.g., libertbank.ge).
              </li>
              <li>
                <strong>A challenge password []:</strong> If you want to protect
                your certificate with a password, enter it here. Otherwise,
                press Enter to skip(Note:etting a password may cause issues with
                certificate integration).
              </li>
              <li>
                <strong> An optional company name []:</strong> This is an
                additional field for your company name. Leave it empty if not
                needed.
              </li>
            </ul>
            <div className="code-snipet">
              <img src="/images/code@2x.png" alt="" />
            </div>
          </div>

          <div className="text-line pb-32">
            <span>
              2 Files will be created after finishing this process. They will be
              located in the same folder where
              <span className="tag">request.bat</span>is.
            </span>
            <div className="pt-10 other-text">
              <p>
                <span className="tag ml-0">client.key</span>– This is your
                Private Key.
              </p>
              <p>
                <span className="tag ml-0">client.req</span> – This file is your
                Certificate Request.
              </p>
              <p>
                Please send<span className="tag">client.req</span> to the
                processing department of our Bank. This request would be signed
                and you will receive<span className="tag">client.cer</span>
              </p>
              <p>This will be your certificate.</p>
              <p>
                In case you need<span className="tag">PEM</span>format you can –
                place client.req in the folder where request was made andrun
                <span className="tag">GEN_PEM.bat</span>
              </p>
              <p>
                Password will be requested and we should press ENTER 3 times.
              </p>
              <p>
                Then new<span className="tag">client.req</span>will be
                generated, which you may use in your application.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
